import styled from 'styled-components';
import { themeGet } from 'styled-system';

const PartnerWrapper = styled.div`
  max-width: 1000px;
  padding: 37px 0;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 991px) {
    padding: 30px 0;
    flex-wrap: wrap;
  }

  p {
    margin: 0 12px 0 0;
    color: ${themeGet('colors.menu', '#0D233E')};
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 991px) {
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 auto;
  }
  img {
    max-width: 140px;
    margin: 0 10px;
    @media only screen and (max-width: 667px) {
      margin: 5px 10px;
    }
  }
`;

export default PartnerWrapper;
